 const NotificationsActionTypes = {
    NOTIFICATION_ADD_START : "NOTIFICATION_ADD_START",
    NOTIFICATION_ADD : "NOTIFICATION_ADD",
    NOTIFICATION_SHOW : "NOTIFICATION_SHOW",
    NOTIFICATION_UNSHOW : "NOTIFICATION_UNSHOW",
    NOTIFICATION_REMOVE : "NOTIFICATION_REMOVE"
}

export default NotificationsActionTypes;